<app-dialog [show]="!hideSelf" [showHeader]="false" id="pending-transaction-dialog" 
  [minWidth]="800" 
  [scrollable]="true"
  scrollableMaxHeight="calc(100vh - 90px)"
  maxHeight="98vh">
    <div class="header-container">
        <div class="header">
            <span class="header-text">Pending transaction details</span>
            <div class="header-details">
                <div>{{pendingTransaction?.integrationType}} |</div>
                <div class="time"><span *ngIf="fillDate"> <span class="font-bold">Filled:</span>  {{fillDate}} </span>
                  <span *ngIf="pendingTransaction?.lastCheckForUpdate"> | <span class="font-bold">Updated: </span>{{pendingTransaction?.lastCheckForUpdate | formattedDate: 'MM d a, HH:mm'}} </span>
                </div>
                <div class="badge">
                  <app-badge *ngIf="pendingTransaction?.activityType === ActivityTypesEnum.Amendment" [color]="BadgeColorsEnum.Blue">
                    Amended
                  </app-badge>
                </div>
            </div>
        </div>
        <div>
          <img [src]="getLogoUrl()" class="logo" [ngClass]="pendingTransaction?.integrationType" alt="logo">
        </div>
    </div>
    <div class="transaction-details">
      <div class="table-container">
        <table>
            <tr class="row-header">
              <td>Rx Number</td>
              <td>Fill #</td>
              <td>Patient</td>
              <td *ngIf="pendingTransaction?.activityType === ActivityTypesEnum.Dispensed">Status</td>
            </tr>
            <tr class="row-value">
              <td>{{pendingTransaction?.rxNumber}}
                <span *ngIf="pendingTransaction?.isPartialFill && pendingTransaction?.partialNumber > 0"> - {{pendingTransaction.partialNumber}}</span>
              </td>
              <td>{{pendingTransaction?.refillNumber}}</td>
              <td class="patient-name">{{pendingTransaction?.patientName}}</td>
               <app-badge *ngIf="pendingTransaction?.activityType === ActivityTypesEnum.Dispensed && !pendingTransaction?.isC2KeepPartialDispense"  [maxWidth]="'200px'">
                {{pendingTransaction?.description?.replace("Picked Up", "P/U")}}
               </app-badge>
               <app-badge *ngIf="pendingTransaction?.isC2KeepPartialDispense"
                [color]="BadgeColorsEnum.Yellow">
                {{pendingTransaction?.description}}
               </app-badge>
            </tr>
          </table>
        </div>
          <div class="c2keep-partial-dispense-details" *ngIf="pendingTransaction?.isC2KeepPartialDispense"> 
            <div class="flex flex-row">
              <img src="assets/icons/icon-exclamation-mark-blue.svg" />
              <span class="action">{{pendingTransaction?.c2KeepPartialDispensedBy}} dispensed {{Math.abs(pendingTransaction?.c2KeepPartialDispensedTotal)}} of {{pendingTransaction?.fullDispenseQuantity}} on {{pendingTransaction?.c2KeepPartialDispensedOn | formattedDate: 'MM d a, HH:mm'}}</span>
            </div>
          </div>
    </div>
   
    <form class="flex flex-col" [formGroup]="splitNdcsForm">
      <div class="amend-reason-date">
          <app-dropdown *ngIf="pendingTransaction?.activityType === ActivityTypesEnum.Amendment" 
                    formControlName="amendReason"
                    [placeholder]="'Select a reason...'"
                    [label]="'Why are you amending this dispense?'" (chosenOption)="changeReason($event)"
                    [options]="amendReasons" [isOptionObject]="true" [isFocused]=""
                    (tabEnterEvent)="dropDownTab()"
                    [highlightFocusedInput]="true"
                    #amendReasonDropdown
                    >
          </app-dropdown>
          <app-datepicker-input [tabInd]="0" 
                    label="Transaction Date/Time"
                    pickerType="both"
                    [initialValue]="transactionDate"
                    formControlName="transactionDateDisplayValue"
                    (dateTimeChange)="dateTimeChanged($event)"
                    [dateMax]="now()"
                    calendarPosition="right"
                    (inputTabKeyDown)="datePickerTabEnter()"
                    #transactionDatePicker>
          </app-datepicker-input>
        </div>
      <div [class.hidden]="amendReason !== 'Other'" class="mb-3 -mt-2">
        <app-input
          formControlName="amendReasonOtherDescription"
          label="Describe Amend Reason"
          type="text"
          (keyupEnter)="otherAmendReasonDescriptionTabEnter()" (keydownTab)="otherAmendReasonDescriptionTabEnter()"
          #amendReasonOtherDescription
        ></app-input>
    </div>
    </form>

    <form [formGroup]="splitNdcsForm" class="table-scroll-wrapper main-scroll-default">
        <table class="table-primary">
          <thead>
            <tr>
              <th class="text-left drug" scope="col">
                Drug
              </th>
              <th class="text-left" scope="col" *ngIf="(inventoryLocationsEnabled$ | async) && pendingTransaction?.activityType !== ActivityTypesEnum.Amendment">
                From Location
              </th>
              <th class="text-right starting" scope="col">
                Start
              </th>
              <th class="text-right count" scope="col">
                Count
              </th>
              <th class="text-right on-hand" scope="col">
                On-Hand
              </th>
              <th class="text-right on-hand" scope="col">
                SOH
              </th>
              <th class="text-left back-count" scope="col" *ngIf="isBackCountEnabledForAny()">
                BACK-COUNT OK?
              </th>
              <th *ngIf="pendingTransaction?.activityType !== ActivityTypesEnum.Amendment || isSplitNdcsAnyDupes()"></th>
            </tr>
          </thead>
          <tbody id="pending">
            <tr class="table-row" *ngIf="!pendingTransaction?.isSplitNdc">
                <td class="text-left drug">
                  <div class="heading">
                    {{pendingTransaction?.friendlyName}} 
                    <img *ngIf="isLackOfInventory" class="alert-icon" src="assets/icons/icon-alert-exclamation-triangle-fill.svg" alt="warning"/>
                  </div>
                  <div class="secondary flex">
                    {{pendingTransaction?.packageNdc}}
                    <div class="flex space-x-2">
                      <app-badge *ngIf="dupTransactionsService.isDup(pendingTransaction?.drugId, splitNdcsForm?.controls?.originalTransactionLocationId?.value)" [color]="BadgeColorsEnum.Red" class="ml-2">
                        Potential Dup
                      </app-badge>
                    </div>
                  </div>
                </td>
                <td class="text-left" *ngIf="(inventoryLocationsEnabled$ | async) && pendingTransaction?.activityType !== ActivityTypesEnum.Amendment"> 
                  <app-inventory-locations-dropdown
                    class="drug"
                    [formControl]="splitNdcsForm.controls.originalTransactionLocationId"
                    [excludeOptions]="getLocationToExcludeForTheOriginalNdcDropdown()"
                    [autoSelectSingleOption]="true"
                  ></app-inventory-locations-dropdown>
                </td>
                <td class="text-right starting">{{pendingTransaction?.starting | number}}</td>
                <td class="text-right count">{{originalCount | number}}</td>
                <td class="text-right on-hand relative" *ngIf="pendingTransaction?.activityType === 0">
                  {{pendingTransaction?.starting - (+originalCount) | number}}
                  <app-back-count-not-resolved-tooltip *ngIf="backCountEnabledForTheOriginalPT"
                    [locationID]="splitNdcsForm?.controls?.originalTransactionLocationId?.value"
                    [drugID]="pendingTransaction?.drugId"
                  ></app-back-count-not-resolved-tooltip>
                </td>
                <td class="text-right on-hand relative" *ngIf="pendingTransaction?.activityType === ActivityTypesEnum.Amendment">
                  {{pendingTransaction?.starting + pendingTransaction?.count | number}}
                  <app-back-count-not-resolved-tooltip *ngIf="backCountEnabledForTheOriginalPT"
                    [locationID]="splitNdcsForm?.controls?.originalTransactionLocationId?.value"
                    [drugID]="pendingTransaction?.drugId"
                  ></app-back-count-not-resolved-tooltip>
                </td>
                <td class="text-right on-hand">
                  <div *ngIf="!!pendingTransaction?.similarOnHand">
                    {{pendingTransaction?.availableSOH | number}}
                  </div>
                
                </td>
                <td class="text-left back-count" *ngIf="isBackCountEnabledForAny()">
                  <app-yes-no-toggle [hidden]="!backCountEnabledForTheOriginalPT"
                   [control]="splitNdcsForm.controls.originalTransactionIsBackCountMatches"
                  ></app-yes-no-toggle>
                </td>
                <td *ngIf="pendingTransaction?.activityType !== ActivityTypesEnum.Amendment">
                  <app-add-note class="block relative cursor-pointer z-10"
                    [friendlyName]="pendingTransaction?.friendlyName"
                    [note]="pendingTransaction?.note"
                    (deleted)="removeNoteFromOriginalPendingTransaction()"
                    (submitted)="addNoteToOriginalPendingTransaction($event)">
                  </app-add-note>
                </td>
            </tr>
            <!-- Split NDC Amends -->
          <ng-container *ngIf="pendingTransaction?.isSplitNdc && pendingTransaction?.activityType === ActivityTypesEnum.Amendment">
            <tr class="table-row" *ngFor="let ndc of pendingTransaction?.splitNdcs; let i0 = index; trackBy:trackByIndex">
              <td class="text-left drug">
                <div class="heading">
                  {{ndc?.friendlyName}} 
                  <img *ngIf="isLackOfInventory" class="alert-icon" src="assets/icons/icon-alert-exclamation-triangle-fill.svg"
                    alt="warning" />
                    <app-badge *ngIf="dupTransactionsService.isDup(ndc?.drugId, ndc.locationId)" [color]="BadgeColorsEnum.Red" 
                      class="ml-2">
                      Potential Dup
                    </app-badge>
                </div>
                <div class="secondary">
                  {{ndc?.packageNdc}}
                </div>
              </td>
              <td class="text-right starting">{{ndc?.starting | number}}</td>
              <td class="text-right count">{{ndc?.count | number}}</td>
              <td class="text-right on-hand">{{ndc?.starting + ndc?.count | number}}</td>
              <td class="text-right on-hand">
                <div *ngIf="ndc?.similarOnHand">
                  {{ndc?.availableSOH | number}}
                </div>
               
              </td>
              <td *ngIf="dupTransactionsService.isDup(ndc?.drugId)">
                <img class="delete space-x-5" src="assets/icons/icon-basket.svg" alt="delete" 
                (click)="removeSplitNdcAmend(ndc?.drugId)"/>
              </td>
              <td class="text-left back-count" *ngIf="isBackCountEnabledForAny()">
                 <app-yes-no-toggle  *ngIf="backCountService.isDrugRequiresBackCount(ndc.drugId)"
                   [control]="splitNdcsForm.controls.amendSplitNdcs.at(i0).get('isBackCountMatches')"
                  ></app-yes-no-toggle>
              </td>
              <td *ngIf="!dupTransactionsService.isDup(ndc?.drugId) && isSplitNdcsAnyDupes()"></td>
            </tr>
          </ng-container>
          
            <!-- Split NDC Dispenses -->
            <ng-container formArrayName="ndcs" *ngFor="let ndc of splitNdcsForm.controls.ndcs?.value; let i = index; trackBy:trackByIndex">
              <tr class="table-row" [formGroupName]="i">
                <td class="text-left drug">
                  <div class="heading">
                    {{ndc?.friendlyName}}
                    <app-badge *ngIf="dupTransactionsService.isDup(ndc?.drugId, ndc?.locationId)" [color]="BadgeColorsEnum.Red" 
                      class="ml-2">
                      Potential Dup
                    </app-badge>
                  </div>
                  <div class="secondary">
                    {{ndc?.packageNdc}}
                  </div>
                </td>
                <td class="text-left" *ngIf="inventoryLocationsEnabled$ | async"> 
                  <app-inventory-locations-dropdown
                    class="drug"
                    [formControl]="splitNdcsForm.controls.ndcs.at(i).get('locationId')"
                    [positiveInventoryBalanceLocationIDs]="inventoryLocationsService.getPositiveInventoryBalanceLocationIDs(splitNdcsForm.controls.ndcs.at(i).get('drugId')?.value)"
                    [excludeOptions]="getLocationToExcludeForTheSplitNdcDropdown(i)"
                  ></app-inventory-locations-dropdown>
                </td>
                <td class="text-right starting">{{ndc?.onHand | number}}</td>
                <td>
                  <app-input
                    [formControl]="splitNdcsForm.controls.ndcs.at(i).get('addedQty')"
                    [type]="'number'"
                    customClasses="-mr-64"
                    [showErrors]="false"
                    textAlign="right"
                    [isNdcQty]="true"
                    >
                  </app-input>
                </td>
                <td class="text-right on-hand relative">
                  {{ndc?.onHand - (+ndc?.addedQty) | number}}
                  <app-back-count-not-resolved-tooltip *ngIf="backCountService.isDrugRequiresBackCount(ndc.drugId)"
                     [locationID]="ndc?.locationId"
                     [drugID]="ndc?.drugId"
                  ></app-back-count-not-resolved-tooltip>
                </td>
                <td class="text-right on-hand">
                  {{ndc?.availableSOH | number}}
                </td>
                <td class="text-left back-count" *ngIf="isBackCountEnabledForAny()">
                  <app-yes-no-toggle  *ngIf="backCountService.isDrugRequiresBackCount(ndc.drugId)"
                   [control]="splitNdcsForm.controls.ndcs.at(i).get('isBackCountMatches')"
                  ></app-yes-no-toggle>
                </td>
                <td>
                  <div class="flex space-x-5">
                     <app-add-note class="block relative cursor-pointer z-10"
                      [friendlyName]="ndc?.friendlyName"
                      [note]="ndc?.note"
                      (deleted)="removeNote(i)"
                      (submitted)="saveAddedNote($event, i)">
                    </app-add-note>

                     <img class="delete" src="assets/icons/icon-basket.svg" alt="delete" 
                         (click)="deleteRow(i)"/>
                  </div>
                 </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
    </form>
    <!-- OWE Workflow (c2keep partial dispense) -->
    <div class="inventory-error" [hidden]="!isLackOfInventory || scriptModified">
        <app-alert [show]="isLackOfInventory"
          [type]="'warning'"
          [hasContent]="true"
        >
          <div class="no-inventory-alert">
            <span class="header">Not Enough Inventory.</span>
            <span class="body">You currently do not have enough inventory for
              <span class="drug"> {{pendingTransaction?.friendlyName}} / {{pendingTransaction?.packageNdc}} </span>
              to confirm this transaction</span>
          </div>
          <div class="flex space-x-6" contentSelect="besideDefaultControls" [formGroup]="splitNdcsForm">
              <app-button
                text="+ Add inventory"
                [minWidth]="140"
                (clicked)="openReceivingModal()"
              >
              </app-button>
              <img src="assets/icons/icon-vertical-divider2.svg"/>
              <app-input class="c2keepPartialAddedQty"
                formControlName="c2keepPartialAddedQty"
                [type]="'number'"
                textAlign="right"
                [isNdcQty]="true"
                [isErrorNoWrap]="true"
                [hideErrorIcon]="true"
                [errorsDescription]="c2keepPartialAddedQtyControlErrorsDescription"
              >
              </app-input>
              <app-button class="!ml-3"
                text="Dispense"
                [minWidth]="97"
                (clicked)="partialDispense()"
              >
              </app-button>
          </div>
        </app-alert>
      </div>
      <div class="flex justify-between mt-4" *ngIf="pendingTransaction?.activityType !== ActivityTypesEnum.Amendment && splitNdcsOn">
        <button class="add-new-drug underline disabled:opacity-60"
          (click)="onAddNewDrugClick()"
          >+ Add Split Fill NDC
        </button>
        <div class="text-[#0369A1]" *ngIf="splitNdcsForm.controls.ndcs?.value?.length">Total count:
          <span class="text-[#13425a] font-medium">{{totalCount | number}}</span>
        </div>
      </div>
      <app-error-message [hidden]="!scriptModified">
        This prescription has changed and cannot be confirmed. Check pending transactions for updates.
      </app-error-message>
      <div class="dialog-controls-default pb-1">
        <app-button customClasses="px-4"
                    text="Cancel"
                    [minWidth]="0"
                    subStyle="transparent"
                    class="cancel-btn"
                    (clicked)="cancelHandler()"
                    (keydownTab)="controlButtonFocusNext()"
                    #cancelButton
        >
        </app-button>
        <div class="flex">
          <app-button *ngIf="!scriptModified"
                      [text]="'Delete'"
                      styleClass="settings"
                      subStyle="white-light-text"
                      customClasses="px-4 mr-4"
                      [minWidth]="0"
                      (clicked)="invalidatePendingTransaction()"
          ></app-button>
          <app-button *ngIf="shouldDisplayGetLatestButton() && !scriptModified"
                      [text]="'Get Latest'"
                      styleClass="settings"
                      subStyle="blue"
                      customClasses="px-4 mr-4 font-semibold"
                      [minWidth]="0"
                      (clicked)="getLatest()"
                      icon="icon-refresh"
          ></app-button>
          <app-button customClasses="px-4" *ngIf="!isLackOfInventory"
                      [text]="getSaveBtnText()"
                      class="save-btn"
                      (clicked)="validateBeforeConfirming()"
                      (keydownTab)="controlButtonFocusNext()"
                      [disabled]="scriptModified"
                      #confirmButton
          >
          </app-button>
        </div>
      </div>

      <app-dialog [show]="loading$ | async" [showHeader]="false" [minWidth]="100" [minHeight]="100">
        <app-loader></app-loader>
      </app-dialog>

      <app-alert class="fixed bottom-[20px] ml-[144px]" [show]="amountExceededError()" type="warning"
        [message]="'The number of additional drugs should not exceed ' + originalNdcTotalCount"
        [textFullWidth]="true"
       >
      </app-alert>
</app-dialog>
<app-enter-pin-dialog [show]="showConfirmTransactionPinDialog || showInvalidateTransactionpinDialog"
                      (cancel)="closePinDialog()"
                      [focusPin]="focusPin"
                      (setPinHandler)="afterPinHandled($event)"
                      (handleResetPin)="openResetPinDialog()"
></app-enter-pin-dialog>

<app-dialog [show]="showErrorPopup" id="error-dialog"
  [showHeader]="false">
  <div class="error-message">
    <span>The original dispense must be confirmed before confirming the Amend</span>
  </div>
  <div class="error-button">
    <app-button customClasses="px-4" text="Cancel" [minWidth]="0" subStyle="transparent" class="cancel-btn"
    (clicked)="showErrorPopup = false">
  </app-button>
  <app-button customClasses="px-4" [text]="'View Dispense'" class="save-btn" (clicked)="openConfirmationDialog()">
  </app-button>
  </div>
</app-dialog>

<app-add-drug-dialog
  [show]="showAddDrugDialog"
  (save)="addSelectedDrug($event)"
  (cancel)="showAddDrugDialog = false"
  (back)="onBackFromNewDrugModal()"
  [ndcs]="selectedDrugs"
  [ndcsToExclude]="getLocationsToExcludeFromInventorySearch()"
  [gpi]="pendingTransaction.gpi"
>
</app-add-drug-dialog>

<app-dialog
  [showHeader]="true"
  [header]="'Are you sure you want to Delete?'"
  [subHeader]="'This record will be permanently deleted.  If records are being sent to C2Keep in error, please let us know.'"
  [maxWidth]="490"
  [minWidth]="560"
  [headerIcon]="'warning'"
  [show]="showDeleteConfirmationDialog">
    <div class="flex justify-between">
        <app-button customClasses="px-4" text="Cancel" [minWidth]="0" subStyle="transparent" class="cancel-btn"
          (clicked)="showDeleteConfirmationDialog = false">
        </app-button>
        <app-button customClasses="px-4" [text]="'Yes, Delete'" class="save-btn" (click)="deleteConfirmed()" [minWidth]="50">
        </app-button>
    </div>
</app-dialog>

<app-dup-transactions-dialog *ngIf="showDupeDispenseModal" 
  (cancel)="cancel.emit()" (save)="reviewed()">
</app-dup-transactions-dialog>
<app-dup-transactions-dialog *ngIf="showDupAmendModal"
  [dialogType]="getDupAmendDialogType()"
  [drugIds]="getExistingDrugIds()"
  (cancel)="cancel.emit()" 
  (save)="reviewed()">
</app-dup-transactions-dialog>

<app-dialog
  [showHeader]="true"
  [header]="'Future / Cycle Fill Alert'"
  [maxWidth]="581"
  [minWidth]="625"
  [headerIcon]="'warning'"
  [show]="showFutureCycleFillAlert"
  saveBtnText="Confirm"
  [hideHeaderUnderline]="true"
  [hasControls]="true"
  (save)="showFutureCycleFillAlert = false; confirmTransaction()"
  (cancel)="showFutureCycleFillAlert = false"
  >
  <div class="text-base leading-6 font-normal mt-1 text-color-text-medium ml-16 mt-[-1rem]">
    This is a potential future / cycle fill for <span class="font-semibold">{{fillDate}}</span> . 
    <br>Do you want to confirm the dispense on <span class="font-semibold">{{transactionDate | formattedDate: 'MM d a, HH:mm'}}</span> instead?
  </div>
</app-dialog>
